import $ from 'jquery';
import { Wireup, ListView } from 'rustig';
import { ClearInputs } from "./util/clearinputs";
import { ShowHide } from './util/showhide';

import './views/index'; // note: load all scripts from views directory to match previous behavior

declare global {
  interface Window {
    Rustig: any;
  }
}

$(function () {
  var app = new Wireup();

  app.push(ShowHide.wireup, $.fn.showhide);

  app.execute()

  ClearInputs.Wireup();
  window.Rustig.ListView = ListView;
});
